import compact from "lodash/compact";
import flatMap from "lodash/flatMap";
import map from "lodash/map";
export default (features) => compact(map(flatMap(features, f => f.get("features")), e => e ? e.get("data") : undefined));
